define([
  './formatters/html/replace-nbsp-chars',
  './formatters/plain-text/escape-html-characters'
], function (
  replaceNbspCharsFormatter,
  escapeHtmlCharactersFormatter
) {
  'use strict';

  return {
    replaceNbspCharsFormatter: replaceNbspCharsFormatter,
    escapeHtmlCharactersFormatter: escapeHtmlCharactersFormatter
  };
});



// WEBPACK FOOTER //
// ./app/statamic/resources/js/vendor/scribe-editor/plugins/core/formatters.js